import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "@perprotocol/ui/foundation.css";
import "./styles.css";

const ModelLab = lazy(() => import("./model-lab/ModelLab"));
const isModelLab = window.location.pathname === "/model-lab" || window.location.pathname === "/model-lab/";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isModelLab
      ? <Suspense fallback={<div className="loading-state"><span />Loading model lab…</div>}><ModelLab /></Suspense>
      : <App />}
  </StrictMode>,
);
